import React from 'react';
import { Text, Loading, Overlay } from '@moda/om';
import { LoadingBalls } from '../../LoadingBalls';

interface Props {
  creating?: boolean;
  retrieving?: boolean;
  updating?: boolean;
  deleting?: boolean;
}

export const ShippingAddressLoading: React.FC<Props> = ({
  creating,
  retrieving,
  updating,
  deleting
}) => {
  if (!creating && !retrieving && !updating && !deleting) {
    return null;
  }

  if (retrieving) {
    return (
      <Overlay show={retrieving}>
        <Loading />
      </Overlay>
    );
  }

  const message: 'Saving' | 'Deleting' = creating || updating ? 'Saving' : 'Deleting';

  return (
    <Overlay show={creating || updating || deleting}>
      <div>
        <LoadingBalls />
      </div>

      <Text treatment="eyebrow"> {message}</Text>
    </Overlay>
  );
};
